// extracted by mini-css-extract-plugin
export default {"list":"SingleItemBox_list__yi6j+"};